module.exports = __webpack_public_path__ + "img/shoe1.092f7c1d.svg";